import { useEffect, useRef } from 'react';
import UserHistory from '../data/userHistories';
import { metadata } from '../data/metadata';

const { UserHistoryRequest } = require('../grpc/generated/account_pb');

/**
 * Custom hook for initial history data fetch
 * Prevents multiple calls and manages history fetching lifecycle
 */
const useHistoryInitialFetch = (accountId, periodKey, marketOption) => {
  const historyRef = useRef(null);
  const requestRef = useRef(null);
  const hasFetchedRef = useRef(false);

  // Initialize only once
  if (!historyRef.current) {
    historyRef.current = new UserHistory();
  }
  if (!requestRef.current) {
    requestRef.current = new UserHistoryRequest();
  }

  // Perform initial fetch
  const fetchHistory = () => {
    historyRef.current.smartFilter(
      requestRef.current,
      metadata(),
      4,
      periodKey,
      accountId
    );
    hasFetchedRef.current = true;
  };

  useEffect(() => {
    // Skip if no account ID
    if (!accountId) {
      return;
    }
    fetchHistory();
  }, [accountId, periodKey, marketOption]);

  // Return instance for manual calls if needed
  return {
    history: historyRef.current,
    request: requestRef.current,
    refetch: () => {
      if (accountId) {
        historyRef.current.smartFilter(
          requestRef.current,
          metadata(),
          periodKey === 6 ? 3 : 4,
          periodKey,
          accountId
        );
      }
    },
    fetchHistory
  };
};

export default useHistoryInitialFetch;
